import { Item } from './SelectPanel/types'
import { Avatar } from '@primer/react'

export const defaultSelectedItems: Array<Item> = [
    {
        id: 3,
        text: 'max',
        description: 'Max Schoening',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/111631?s=80&v=4" />
        ),
    },
    {
        id: 4,
        text: 'jonrohan',
        description: 'Jon Rohan',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/54012?s=60&v=4" />
        ),
    },
]
export const defaultItems: Array<Item> = [
    {
        id: 3,
        text: 'max',
        description: 'Max Schoening',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/111631?s=80&v=4" />
        ),
    },
    {
        id: 4,
        text: 'jonrohan',
        description: 'Jon Rohan',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/54012?s=60&v=4" />
        ),
    },
    {
        id: 5,
        text: 'howdyray',
        description: 'Rachel Cohen',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/3454298?s=80&v=4" />
        ),
    },
    {
        id: 6,
        text: 'tbenning',
        description: 'Tyler Benning',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/7265547?s=80&v=4" />
        ),
    },
    {
        id: 7,
        text: 'cheshire137',
        description: 'Sarah Vessels',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/82317?s=60&v=4" />
        ),
    },
    {
        id: 8,
        text: 'technoweenie',
        description: 'technoweenie',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/21?s=60&v=4" />
        ),
    },
    {
        id: 9,
        text: 'tobiasahlin',
        description: 'Tobias Ahlin',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/211284?s=60&v=4" />
        ),
    },
    {
        id: 10,
        text: 'dgraham',
        description: 'David Graham',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/122102?s=60&v=4" />
        ),
    },
    {
        id: 11,
        text: 'mdo',
        description: 'Mark Otto',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/98681?s=60&v=4" />
        ),
    },
    {
        id: 12,
        text: 'tclem',
        description: 'Timothy Clem',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/136521?s=60&v=4" />
        ),
    },
    {
        id: 13,
        text: 'oreoshake',
        description: 'Neil Matatall',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/448516?s=60&v=4" />
        ),
    },
    {
        id: 14,
        text: 'latentflip',
        description: 'Philip Roberts',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/78225?s=60&v=4" />
        ),
    },
    {
        id: 15,
        text: 'koddsson',
        description: 'Kristján Oddsson',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/318208?s=60&v=4" />
        ),
    },
    {
        id: 16,
        text: 'shayfrendt',
        description: 'Shay Frendt',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/32535?s=60&v=4" />
        ),
    },
    {
        id: 17,
        text: 'dmarcey',
        description: 'Derrick Marcey',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/5487287?s=60&v=4" />
        ),
    },
    {
        id: 18,
        text: 'benbalter',
        description: 'Ben Balter',
        descriptionVariant: 'inline',
        leadingVisual: (
            <Avatar src="https://avatars.githubusercontent.com/u/282759?s=60&v=4" />
        ),
    },
]
